import { Role } from "../../types/role";

const DMve: Role = {
  primary: [
    "Tackling",
    "Antizipation",
    "Einsatzfreude",
    "Konzentration",
    "Stellungsspiel",
    "Teamwork",
    "Ausdauer",
  ],
  secondary: [
    "Deckung",
    "Passen",
    "Aggressivitaet",
    "Entscheidungen",
    "Nervenstaerke",
    "Kraft",
  ],
  physis: "mittelfeld",
};
const DMun: Role = {
  primary: [
    "Tackling",
    "Antizipation",
    "Einsatzfreude",
    "Konzentration",
    "Stellungsspiel",
    "Teamwork",
    "Ausdauer",
  ],
  secondary: [
    "Ballannahme",
    "Deckung",
    "Passen",
    "Aggressivitaet",
    "Entscheidungen",
    "Nervenstaerke",
    "Kraft",
  ],
  physis: "mittelfeld",
};

export const DM = {
  DMve,
  DMun,
};
